// src/pages/admin/AdminEditListing.js
// Formulaire de modification d'annonce (admin) - NE PAS MODIFIER

import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import ROUTES from '../../constants/routes';
import { CATEGORIES } from '../../data/categories';
import { getTypesByCategory } from '../../data/listingTypes';
import { QUARTIERS, CITIES } from '../../data/quartiers';
import { LISTING_STATUS, LISTING_STATUS_LABELS } from '../../constants/listingStatus';
import LoadingSpinner from '../../components/shared/LoadingSpinner';

const AdminEditListing = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [category, setCategory] = useState('locations');
  const [form, setForm] = useState({
    title: '',
    type: '',
    quartier: '',
    city: 'Douala',
    price: '',
    bedrooms: '',
    bathrooms: '',
    area: '',
    capacity: '',
    floor: '',
    legalStatus: '',
    viabilise: false,
    cloture: false,
    proLabel: '',
    coveredAreas: '',
    description: '',
    descriptionEn: '',
    lat: '',
    lng: '',
    ownerName: '',
    ownerPhone: '',
    amenities: '',
    status: LISTING_STATUS.PUBLISHED,
  });

  useEffect(() => {
    // Charger l'annonce existante (à remplacer par adminListingsAPI.getDetail(id))
    const demoListing = {
      id: parseInt(id),
      title: 'Appartement moderne meublé',
      type: 'apartment2',
      quartier: 'Bonapriso',
      city: 'Douala',
      category: 'locations',
      price: '250000',
      bedrooms: '2',
      bathrooms: '1',
      area: '85',
      floor: '2ème',
      description: 'Magnifique appartement moderne entièrement meublé au cœur de Bonapriso.',
      descriptionEn: 'Beautiful modern fully furnished apartment in the heart of Bonapriso.',
      lat: '4.0511',
      lng: '9.7679',
      ownerName: 'M. Kamga',
      ownerPhone: '+237640460565',
      amenities: 'Wifi, Climatisation, Parking, Sécurité 24/7',
      status: LISTING_STATUS.PUBLISHED,
    };

    setTimeout(() => {
      setCategory(demoListing.category);
      setForm({
        ...form,
        ...demoListing,
        price: String(demoListing.price),
      });
      setLoading(false);
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSave = async () => {
    if (!form.title || !form.type || !form.quartier || !form.ownerPhone) {
      alert('Veuillez remplir les champs obligatoires (*)');
      return;
    }

    setSaving(true);
    try {
      const listingData = {
        ...form,
        category,
        amenities: form.amenities ? form.amenities.split(',').map((a) => a.trim()) : [],
      };
      // TODO: adminListingsAPI.update(id, listingData)
      console.log('Annonce modifiée:', listingData);
      await new Promise((resolve) => setTimeout(resolve, 800));
      navigate(ROUTES.ADMIN_LISTINGS);
    } catch (error) {
      alert('Erreur lors de la modification');
    } finally {
      setSaving(false);
    }
  };

  const types = getTypesByCategory(category);
  const quartiersForCity = QUARTIERS.filter((q) => q.city === form.city);

  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      maxWidth: '900px',
      margin: '0 auto',
      backgroundColor: '#0A0E1A',
      paddingBottom: '80px',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '16px 20px',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      position: 'sticky',
      top: 0,
      backgroundColor: '#0A0E1A',
      zIndex: 50,
    },
    backButton: {
      background: 'none',
      border: 'none',
      color: '#FFFFFF',
      fontSize: '20px',
      cursor: 'pointer',
    },
    title: { fontSize: '20px', fontWeight: '700', color: '#FFFFFF' },
    form: { padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' },
    field: { display: 'flex', flexDirection: 'column', gap: '6px' },
    row: { display: 'flex', gap: '12px' },
    label: { fontSize: '13px', fontWeight: '600', color: '#A0AEC0' },
    required: { color: '#F56565' },
    input: {
      padding: '12px 14px',
      backgroundColor: '#111827',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '8px',
      color: '#FFFFFF',
      fontSize: '15px',
      outline: 'none',
      width: '100%',
    },
    select: {
      padding: '12px 14px',
      backgroundColor: '#111827',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '8px',
      color: '#FFFFFF',
      fontSize: '15px',
      outline: 'none',
      width: '100%',
    },
    textarea: {
      padding: '12px 14px',
      backgroundColor: '#111827',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      borderRadius: '8px',
      color: '#FFFFFF',
      fontSize: '15px',
      outline: 'none',
      minHeight: '90px',
      resize: 'vertical',
      fontFamily: 'inherit',
    },
    sectionLabel: {
      fontSize: '14px',
      fontWeight: '700',
      color: '#FFD700',
      marginTop: '8px',
    },
    bottomBar: {
      position: 'fixed',
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      width: '100%',
      maxWidth: '900px',
      display: 'flex',
      gap: '10px',
      padding: '12px 20px',
      backgroundColor: '#0A0E1A',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
    },
    saveBtn: {
      flex: 1,
      padding: '14px',
      backgroundColor: '#FFD700',
      border: 'none',
      borderRadius: '10px',
      color: '#0A0E1A',
      fontSize: '15px',
      fontWeight: '700',
      cursor: 'pointer',
    },
  };

  if (loading) {
    return <LoadingSpinner fullScreen message="Chargement de l'annonce..." />;
  }

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Modifier l'annonce | Fynho Admin</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <button style={styles.backButton} onClick={() => navigate(ROUTES.ADMIN_LISTINGS)}>←</button>
        <div style={styles.title}>Modifier #{id}</div>
      </div>

      <div style={styles.form}>
        <div style={styles.field}>
          <label style={styles.label}>Titre <span style={styles.required}>*</span></label>
          <input type="text" style={styles.input} value={form.title} onChange={(e) => handleChange('title', e.target.value)} />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Type <span style={styles.required}>*</span></label>
          <select style={styles.select} value={form.type} onChange={(e) => handleChange('type', e.target.value)}>
            <option value="">Choisir un type</option>
            {types.map((t) => (
              <option key={t.id} value={t.id}>{t.name}</option>
            ))}
          </select>
        </div>

        <div style={styles.row}>
          <div style={{ ...styles.field, flex: 1 }}>
            <label style={styles.label}>Ville <span style={styles.required}>*</span></label>
            <select style={styles.select} value={form.city} onChange={(e) => { handleChange('city', e.target.value); handleChange('quartier', ''); }}>
              {CITIES.map((city) => (
                <option key={city} value={city}>{city}</option>
              ))}
            </select>
          </div>
          <div style={{ ...styles.field, flex: 1 }}>
            <label style={styles.label}>Quartier <span style={styles.required}>*</span></label>
            <select style={styles.select} value={form.quartier} onChange={(e) => handleChange('quartier', e.target.value)}>
              <option value="">Choisir</option>
              {quartiersForCity.map((q) => (
                <option key={q.id} value={q.name}>{q.name}</option>
              ))}
            </select>
          </div>
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Prix (FCFA)</label>
          <input type="number" style={styles.input} value={form.price} onChange={(e) => handleChange('price', e.target.value)} />
        </div>

        {(category === 'sejours' || category === 'locations') && (
          <div style={styles.row}>
            <div style={{ ...styles.field, flex: 1 }}>
              <label style={styles.label}>Chambres</label>
              <input type="number" style={styles.input} value={form.bedrooms} onChange={(e) => handleChange('bedrooms', e.target.value)} />
            </div>
            <div style={{ ...styles.field, flex: 1 }}>
              <label style={styles.label}>Salles de bain</label>
              <input type="number" style={styles.input} value={form.bathrooms} onChange={(e) => handleChange('bathrooms', e.target.value)} />
            </div>
          </div>
        )}

        <div style={styles.field}>
          <label style={styles.label}>Superficie (m²)</label>
          <input type="number" style={styles.input} value={form.area} onChange={(e) => handleChange('area', e.target.value)} />
        </div>

        <div style={styles.field}>
          <label style={styles.label}>Équipements (séparés par virgule)</label>
          <input type="text" style={styles.input} value={form.amenities} onChange={(e) => handleChange('amenities', e.target.value)} />
        </div>

        <div style={styles.sectionLabel}>Descriptions</div>
        <div style={styles.field}>
          <label style={styles.label}>Description (Français)</label>
          <textarea style={styles.textarea} value={form.description} onChange={(e) => handleChange('description', e.target.value)} />
        </div>
        <div style={styles.field}>
          <label style={styles.label}>Description (English)</label>
          <textarea style={styles.textarea} value={form.descriptionEn} onChange={(e) => handleChange('descriptionEn', e.target.value)} />
        </div>

        <div style={styles.sectionLabel}>Localisation GPS</div>
        <div style={styles.row}>
          <div style={{ ...styles.field, flex: 1 }}>
            <label style={styles.label}>Latitude</label>
            <input type="text" style={styles.input} value={form.lat} onChange={(e) => handleChange('lat', e.target.value)} />
          </div>
          <div style={{ ...styles.field, flex: 1 }}>
            <label style={styles.label}>Longitude</label>
            <input type="text" style={styles.input} value={form.lng} onChange={(e) => handleChange('lng', e.target.value)} />
          </div>
        </div>

        <div style={styles.sectionLabel}>Contact propriétaire</div>
        <div style={styles.field}>
          <label style={styles.label}>Nom du propriétaire</label>
          <input type="text" style={styles.input} value={form.ownerName} onChange={(e) => handleChange('ownerName', e.target.value)} />
        </div>
        <div style={styles.field}>
          <label style={styles.label}>WhatsApp / Téléphone <span style={styles.required}>*</span></label>
          <input type="tel" style={styles.input} value={form.ownerPhone} onChange={(e) => handleChange('ownerPhone', e.target.value)} />
        </div>

        <div style={styles.sectionLabel}>Statut</div>
        <div style={styles.field}>
          <select style={styles.select} value={form.status} onChange={(e) => handleChange('status', e.target.value)}>
            {Object.entries(LISTING_STATUS_LABELS).map(([value, label]) => (
              <option key={value} value={value}>{label}</option>
            ))}
          </select>
        </div>
      </div>

      <div style={styles.bottomBar}>
        <button
          style={{ ...styles.saveBtn, opacity: saving ? 0.6 : 1 }}
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? 'Enregistrement...' : 'Enregistrer les modifications'}
        </button>
      </div>
    </div>
  );
};

export default AdminEditListing;